/**
 * seo-mixin.js
 * 通用 SEO mixin，所有工具组件引入此文件即可自动设置独立 SEO 信息
 *
 * 用法:
 *   import seoMixin from '@/js/seo-mixin';
 *   export default {
 *     mixins: [seoMixin],
 *     data() {
 *       return {
 *         seoTitle: 'PDF转Word - FreeToolBox 免费在线工具箱',
 *         seoDescription: '免费在线PDF转Word转换器，浏览器本地处理，保护隐私，支持批量转换。',
 *         seoKeywords: 'pdf转word,pdf转换,word转换,免费pdf转换'
 *       }
 *     }
 *   }
 */

const SITE_NAME = 'FreeToolBox - 免费在线工具箱';

export default {
  mounted() {
    this.updateSEO();
  },
  beforeDestroy() {
    // 离开页面时恢复默认标题，避免影响其他页面
    document.title = SITE_NAME;
  },
  watch: {
    seoTitle() { this.updateSEO(); },
    seoDescription() { this.updateSEO(); },
  },
  methods: {
    updateSEO() {
      const title = this.seoTitle || SITE_NAME;
      const description = this.seoDescription || 'FreeToolBox 提供多种免费在线工具，包括PDF转换、图片处理、格式转换等高效工具';
      const keywords = this.seoKeywords || '在线工具,免费工具,PDF转换,图片处理,格式转换,GIF生成,JSON格式化';

      // 1. 动态标题
      document.title = title;

      // 2. 更新 meta 标签
      this.updateMeta('description', description);
      this.updateMeta('keywords', keywords);

      // 3. Open Graph
      this.updateMeta('og:title', title, 'property');
      this.updateMeta('og:description', description, 'property');
      this.updateMeta('og:type', 'website', 'property');
      this.updateMeta('og:url', window.location.href, 'property');

      // 4. Canonical（防止重复内容）
      this.updateCanonical(window.location.href);
    },

    updateMeta(name, content, attr = 'name') {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    },

    updateCanonical(url) {
      let el = document.querySelector('link[rel="canonical"]');
      if (!el) {
        el = document.createElement('link');
        el.rel = 'canonical';
        document.head.appendChild(el);
      }
      el.href = url;
    }
  }
};
